import { useEffect } from 'react'

import keycloak, { initKeycloak } from 'services/auth/keycloak'

const Login = () => {
  useEffect(() => {
    let isMounted = true

    const appUri = `${window.location.origin}/app?activateModule=true`

    initKeycloak()
      .then(authenticated => {
        if (!isMounted) {
          return
        }

        if (authenticated) {
          window.location.replace(appUri)
        } else {
          keycloak.login({ redirectUri: appUri })
        }
      })
      .catch(() => {
        if (isMounted) {
          keycloak.login({ redirectUri: appUri })
        }
      })

    return () => {
      isMounted = false
    }
  }, [])

  return null
}

export default Login
